import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["sectionComponent", "componentProps", "widget", "isForm"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import QuestionsFields from '@/components/Editor/Form/Questions';
import OverviewFields from '@/components/Editor/Form/OverviewFields';
import StackedBarsFields from '@/components/Editor/Form/StackedBarsFields';
import ListFields from '@/components/Editor/Form/ListFields';
import TableFields from '@/components/Editor/Form/TableFields';
import ReceiptFields from '@/components/Editor/Form/ReceiptFields';
import TreeMapFields from '@/components/Editor/Form/TreeMapFields';
import PieDoughnutFields from '@/components/Editor/Form/PieDoughnutFields';
import PointChartFields, { defaultProps as pointChartDefaultProps } from '@/components/Editor/Form/PointChartFields';
import BarChartBaseFields from '@/components/Editor/Form/barChart/BarChartBaseFields';
import LineChartFields from '@/components/Editor/Form/LineChartFields';
import RadarChartFields from '@/components/Editor/Form/RadarChartFields';
import GaugeChartFields from '@/components/Editor/Form/GaugeChartFields';
import { jsx as _jsx } from "react/jsx-runtime";
const COMPONENT_FIELDS_MAP = {
  Overview: OverviewFields,
  BarChart: BarChartBaseFields,
  StackedBarChart: BarChartBaseFields,
  LineChart: LineChartFields,
  GaugeChart: GaugeChartFields,
  StackedBars: StackedBarsFields,
  List: ListFields,
  Table: TableFields,
  TreeMap: TreeMapFields,
  PieDoughnut: PieDoughnutFields,
  Bubble: PointChartFields,
  Scatter: PointChartFields,
  Receipt: ReceiptFields,
  RadarChart: RadarChartFields
};

const EditSectionGeneralFields = _ref => {
  let {
    sectionComponent,
    componentProps = {},
    widget,
    isForm
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  const nameSpace = `${props.sectionId}-${widget.id}`;
  const CurrentComponent = isForm ? QuestionsFields : COMPONENT_FIELDS_MAP[sectionComponent];
  const fieldsProps = useMemo(() => {
    // Component specific props
    // used to override the default component settings
    const defaultComponentProps = _objectSpread({}, pointChartDefaultProps);

    return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, props), defaultComponentProps[sectionComponent] || {}), componentProps[sectionComponent] || {}), isForm ? {
      widgetId: props.reportingWidgetId
    } : {});
  }, [props, isForm, sectionComponent, componentProps]);

  if (!CurrentComponent) {
    return null;
  }

  return /*#__PURE__*/_jsx(CurrentComponent, _objectSpread({
    widgetId: widget.id,
    nameSpace: nameSpace,
    component: sectionComponent
  }, fieldsProps));
};

export default EditSectionGeneralFields;